import { type ClassName, tw, twx } from '@ctw/shared/utils/tailwind';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { PropsWithChildren } from 'react';

export interface CollapsibleContentProps extends PropsWithChildren {
  label: string;
  secondaryLabel?: string;
  initiallyOpen?: boolean;
  onToggle?: (open: boolean) => void;
  summaryClassName?: ClassName;
}

export const CollapsibleContent = ({
  label,
  secondaryLabel,
  initiallyOpen = false,
  children,
  onToggle,
  summaryClassName,
}: CollapsibleContentProps) => {
  return (
    <details
      open={initiallyOpen}
      onClick={(event) => {
        event.stopPropagation();
      }}
      onToggle={(event) => {
        event.stopPropagation();

        onToggle?.(event.newState === 'open');
      }}
      className={tw`collapsible-content group/collapsible`}
    >
      <summary
        className={twx(
          'flex cursor-pointer items-start justify-between gap-1 pb-2 hover:opacity-80',
          summaryClassName,
        )}
      >
        <div className={tw`flex flex-col`}>
          <div className={tw`font-medium text-base text-primary-text tracking-wide`}>{label}</div>
          {secondaryLabel && (
            <div className={tw`font-normal text-content-subtle text-sm`}>{secondaryLabel}</div>
          )}
        </div>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={tw`mt-0.5 h-5 w-5 shrink-0 text-primary-main group-open/collapsible:scale-y-[-1]`}
        />
      </summary>

      <div
        className={tw`h-0 opacity-0 transition-all duration-300 group-open/collapsible:h-max group-open/collapsible:opacity-100`}
      >
        {children}
      </div>
    </details>
  );
};
